export const mapBackendToForm = (data) => {
  if (!data) return {};

  const dateFields = [
    "doctor_anaesthetist_signature_date_time",
    "doctor_signature_unable_consent_date_time",
    "interpreter_signature_date_time",
    "interpreter_signature_unable_consent_date_time",
    "patient_rep_signature_date_time",
    "patient_signature_date_time",
    "witness_signature_date_time",
    "witness_signature_unable_consent_date_time",
  ];

  const formattedDates = {};
  dateFields.forEach(field => {
    if (data[field]) {
      const date = new Date(data[field]);
      if (!isNaN(date.getTime())) {
        formattedDates[field] = date.toISOString().slice(0, 16);
      }
    }
  });

  // Ensure nulls become empty strings
  const sanitized = Object.keys(data).reduce((acc, key) => {
    acc[key] = data[key] === null ? '' : data[key];
    return acc;
  }, {});

  return {
    ...sanitized,
    ...formattedDates
  };
};

export const mapFormToBackend = (formData) => {
  return {
    ...formData,
    hospital_id: 1,
  };
};

export const validateHighRiskForm = (formData) => {
  const errors = {};
  const requiredFields = [
    { key: 'procedure_by_dr', label: "Doctor's Name" },
    { key: 'primary_disease', label: 'Primary Disease' },
    { key: 'associated_risk_factor', label: 'Associated Risk Factor' },
    { key: 'complications', label: 'Complications' },
  ];

  requiredFields.forEach(({ key, label }) => {
    if (!formData[key] || String(formData[key]).trim() === '') {
      errors[key] = `${label} is required`;
    }
  });

  return errors;
};
